<template>
    <div class="alert-message alert" :class="alertClass">
        <span v-html="text"></span>
        <button v-if="closable" type="button" class="btn close" aria-label="Close" @click="removeNotification(0)"><span>&times;</span></button>
    </div>
</template>

<script>
import { mapActions } from 'pinia';
import { useRootStore } from '../stores/root';

export default {
    name: "AlertMessage",

    props: {
        type: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        closable: Boolean
    },

    computed: {
        alertClass() {
            return {
                'alert-success': this.type === 'success',
                'alert-warning': this.type === 'warning',
                'alert-danger': this.type === 'danger'
            };
        }
    },

    methods: {
        ...mapActions(useRootStore, ['removeNotification'])
    }
}
</script>

<style scoped>
.alert-message {
    width: 100%;
    margin: 0;
    padding: 0.75em 1em;
}
</style>
